import RequestAccessButton from './RequestAccessButton.container';

export default RequestAccessButton;
